<template>
<!-- active-element inactive-element -->
    <div class="order-progress">
        <hr>
        <div class="order-progress-element" v-bind:class="step == 1 ? 'active-element' : 'inactive-element'">
            <h2>1</h2>
            <p>Punkt podjęcia</p>
        </div>
        <div class="order-progress-element" v-bind:class="step == 2 ? 'active-element' : 'inactive-element'">
            <h2>2</h2>
            <p>Adres realizacji</p>
        </div>
        <div class="order-progress-element" v-bind:class="step == 3 ? 'active-element' : 'inactive-element'">
            <h2>3</h2>
            <p>Numery zamówień</p>
        </div>
        <div class="order-progress-element" v-bind:class="step == 4 ? 'active-element' : 'inactive-element'">
            <h2>4</h2>
            <p>Termin dostawy</p>
        </div>
        <div class="order-progress-element" v-bind:class="step == 5 || step == 6 ? 'active-element' : 'inactive-element'">
            <h2>5</h2>
            <p>Podsumowanie</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'stepBar',
        props: ['step'],
        data () {
            return {

            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// StepBar.vue?79ca554c